import { createSlice } from "@reduxjs/toolkit";
import {
  fetchExpenses,
  fetchExpenseCategories,
  fetchLastPayeeByCategory,
  addExpense,
  updateExpense,
  deleteExpense,
} from "./academyExpense.thunk";

const initialState = {
  expenses: [],
  categories: [],
  lastPayee: null,
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  summary: { total_amount: 0 },
  loading: false,
  categoriesLoading: false,
  lastPayeeLoading: false,
  error: null,
  selectedExpense: null,
};

const academyExpenseSlice = createSlice({
  name: "academyExpense",
  initialState,

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedExpense: (state, action) => {
      state.selectedExpense = action.payload;
    },
    clearSelectedExpense: (state) => {
      state.selectedExpense = null;
    },
    clearLastPayee: (state) => {
      state.lastPayee = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ===== FETCH EXPENSES ===== */
      .addCase(fetchExpenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.expenses = action.payload.data;
        state.summary = action.payload.summary || { total_amount: 0 };
        state.totalPages = action.payload.meta.total_pages;
        state.total = action.payload.meta.total;
        state.limit = action.payload.meta.limit;
      })
      .addCase(fetchExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== FETCH CATEGORIES ===== */
      .addCase(fetchExpenseCategories.pending, (state) => {
        state.categoriesLoading = true;
      })
      .addCase(fetchExpenseCategories.fulfilled, (state, action) => {
        state.categoriesLoading = false;
        state.categories = action.payload;
      })
      .addCase(fetchExpenseCategories.rejected, (state, action) => {
        state.categoriesLoading = false;
        state.error = action.payload;
      })

      /* ===== FETCH LAST PAYEE ===== */
      .addCase(fetchLastPayeeByCategory.pending, (state) => {
        state.lastPayeeLoading = true;
        state.lastPayee = null;
      })
      .addCase(fetchLastPayeeByCategory.fulfilled, (state, action) => {
        state.lastPayeeLoading = false;
        state.lastPayee = action.payload;
      })
      .addCase(fetchLastPayeeByCategory.rejected, (state, action) => {
        state.lastPayeeLoading = false;
        state.lastPayee = null;
        state.error = action.payload;
      })

      /* ===== ADD EXPENSE ===== */
      .addCase(addExpense.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== UPDATE EXPENSE ===== */
      .addCase(updateExpense.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== DELETE EXPENSE ===== */
      .addCase(deleteExpense.fulfilled, (state, action) => {
        state.expenses = state.expenses.filter(
          (ex) => ex.id !== action.payload.id
        );
      })
      .addCase(deleteExpense.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const {
  setCurrentPage,
  setSelectedExpense,
  clearSelectedExpense,
  clearLastPayee,
} = academyExpenseSlice.actions;

export default academyExpenseSlice.reducer;